import { render, staticRenderFns } from "./RichTextLenderPayoutBox.vue?vue&type=template&id=d6cb83c6&scoped=true&"
import script from "./RichTextLenderPayoutBox.vue?vue&type=script&lang=js&"
export * from "./RichTextLenderPayoutBox.vue?vue&type=script&lang=js&"
import style0 from "./RichTextLenderPayoutBox.vue?vue&type=style&index=0&id=d6cb83c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6cb83c6",
  null
  
)

export default component.exports